module.exports = __webpack_public_path__ + "static/media/payment-success.6decc91c.svg";